var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[_c('HomeBackground'),_c('HomeJobstream'),_c('HomePresentation'),_c('HomePartenaire'),_c('HomeAccomp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }